export enum BovagTermsTypeEnum {
    PRIVATE = "private",
    BUSINESS = "business",
}
